
// src/actions/sub-diaries.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_SUB_DIARIES = "FETCH_SUB_DIARIES"
export const FETCH_SUB_DIARIES_REQUESTED = "FETCH_SUB_DIARIES_REQUESTED"
export const FETCH_SUB_DIARIES_COMPLETED = "FETCH_SUB_DIARIES_COMPLETED"
export const FETCH_SUB_DIARIES_FAILED = "FETCH_SUB_DIARIES_FAILED"

export function fetchSubDiariesRequested() {
  return {
    type: FETCH_SUB_DIARIES_REQUESTED
  }
}

// conditions:
//   user_id: ユーザid
//   diary_ids: 投稿idのリスト
//   unread: 未読の投稿のみ
//   category: 投稿種別(diary, memo, kpi)
//   reported_at_only: 投稿日指定
export function fetchSubDiaries(group_id, offset, conditions = {}) {
  return function(dispatch) {
    dispatch(fetchSubDiariesRequested())
    conditions = Object.assign(conditions, { group_id, offset })
    return api.get(`/diaries`, conditions)
        .then((results)=> {
          dispatch(fetchSubDiariesCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchSubDiariesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchSubDiariesCompleted(results, offset) {
  return {
    type: FETCH_SUB_DIARIES_COMPLETED,
    results, offset
  }
}

export function fetchSubDiariesFailed(error) {
  return {
    type: FETCH_SUB_DIARIES_FAILED,
    error,
  }
}

export const FETCH_SUB_DIARY = "FETCH_SUB_DIARY"
export const FETCH_SUB_DIARY_REQUESTED = "FETCH_SUB_DIARY_REQUESTED"
export const FETCH_SUB_DIARY_COMPLETED = "FETCH_SUB_DIARY_COMPLETED"
export const FETCH_SUB_DIARY_FAILED = "FETCH_SUB_DIARY_FAILED"

export function fetchSubDiaryRequested() {
  return {
    type: FETCH_SUB_DIARY_REQUESTED
  }
}

export function fetchSubDiary(diary_id, with_all_likes_readers = true) {
  return function(dispatch) {
    dispatch(fetchSubDiaryRequested())
    return api.get(`/diaries/${diary_id}`, { with_all_likes_readers })
        .then((results)=> {
          dispatch(fetchSubDiaryCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchSubDiaryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchSubDiaryCompleted(results) {
  return {
    type: FETCH_SUB_DIARY_COMPLETED,
    results,
  }
}

export function fetchSubDiaryFailed(error) {
  return {
    type: FETCH_SUB_DIARY_FAILED,
    error,
  }
}

export const SEARCH_DIARIES = "SEARCH_DIARIES"
export const SEARCH_DIARIES_REQUESTED = "SEARCH_DIARIES_REQUESTED"
export const SEARCH_DIARIES_COMPLETED = "SEARCH_DIARIES_COMPLETED"
export const SEARCH_DIARIES_FAILED = "SEARCH_DIARIES_FAILED"

export function searchDiariesRequested() {
  return {
    type: SEARCH_DIARIES_REQUESTED
  }
}

// conditions:
//   user_ids: ユーザidのリスト
//   category: 投稿種別(diary, memo, kpi)
//   start_date, end_date: 投稿日の期間指定
//   files_attached: 添付ファイルがあるものに限定
//   query: 検索キーワード
export function searchDiaries(group_id, offset, conditions = {}) {
  return function(dispatch) {
    dispatch(searchDiariesRequested())
    conditions = Object.assign(conditions, { group_id, offset })
    return api.get(`/diaries/search`, conditions)
        .then((results)=> {
          dispatch(searchDiariesCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(searchDiariesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function searchDiariesCompleted(results, offset) {
  return {
    type: SEARCH_DIARIES_COMPLETED,
    results, offset
  }
}

export function searchDiariesFailed(error) {
  return {
    type: SEARCH_DIARIES_FAILED,
    error,
  }
}

export const CLEAR_SUB_DIARIES = "CLEAR_SUB_DIARIES"

export function clearSubDiaries() {
  return {
    type: CLEAR_SUB_DIARIES
  }
}

export const LOAD_DIARY_TO_SUB_DIARIES = "LOAD_DIARY_TO_SUB_DIARIES"

export function loadDiaryToSubDiaries(diary) {
  return {
    type: LOAD_DIARY_TO_SUB_DIARIES,
    diary
  }
}


// WEBPACK FOOTER //
// ./src/actions/sub-diaries.js